// get youtube ID for given video URL

function getYtId(url) {
  // if not a youtube url, return false
  const reg =
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
  const match = url.match(reg);

  if (!match) return false;

  return match[1];
}

export default getYtId;
